var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "participation" }, [
    _c(
      "div",
      { staticClass: "participation__wrapper" },
      [
        _c("BaseTitle", {
          staticClass: "participation__title  title",
          attrs: { text: _vm.titleText }
        }),
        _c("ParticipationList"),
        _c("BaseBtn", {
          attrs: { text: _vm.btnText, customClass: "default", to: "/terms" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c5fd267", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5fd267","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/ParticipationBlock.vue
// module id = svbY
// module chunks = 0